export const CategoryHeaderBase = ({ children, classes, ...props }) => {
  return (
    <div className={`category-header ${classes || ''}`} {...props}>
      {children}
    </div>
  );
};
